import { API_BASE_URL } from '@/constants/api.constant.ts';
import { DASHBOARD_PREFIX_PATH, DASHBOARD_ROUTES, SIGN_IN } from '@/constants/route.constant.ts';

export type AppConfig = {
  apiBaseUrl: string;
  authenticatedEntryPath: string;
  unAuthenticatedEntryPath: string;
  locale: string;
  enableMock: boolean;
  activeNavTranslation: boolean;
};

const appConfig: AppConfig = {
  apiBaseUrl: API_BASE_URL,
  locale: 'en',
  enableMock: true,
  activeNavTranslation: false,
  authenticatedEntryPath: `${DASHBOARD_PREFIX_PATH}/${DASHBOARD_ROUTES.ANALYTIC}`,
  unAuthenticatedEntryPath: SIGN_IN,
};

export default appConfig;
